import { FC, useState } from 'react'
import { Actions, Content, Header } from '../userProfile.styles'
import { Box, CircularProgress, IconButton, Typography } from '@mui/material'
import { CloseChipIcon } from '../../../../svg'
import { ThemeButton } from '../../../../buttons'
import { closeModal, modalPropsSelector, setModalProps } from '../../../../../../store/modals/modalSlice'
import { useAppDispatch, useAppSelector } from '../../../../../../store/hooks'
import { closeToast, openToast, ToastVariant } from '../../../../../../store/toasts/toastSlice'
import { UserServiceV4 } from 'services'
import { useAuth } from '@frontegg/react'
import { Form, Formik } from 'formik'
import { nameSchema } from './user-modal.constants'
import ControlledTextField from '../../../../form-components/ControlledTextField'

interface FormValues {
  name: string
}

const ChangeName: FC = () => {
  const dispatch = useAppDispatch()
  const modalProps = useAppSelector(modalPropsSelector)
  const [loading, setLoading] = useState(false)
  const { user } = useAuth()

  const initialValues = { name: modalProps.props?.user?.name || '' }

  const handleClose = () => {
    dispatch(closeModal())
  }

  const handleSave = async (values: FormValues) => {
    const userId = modalProps?.props?.user?.id
    if (!userId) return
    setLoading(true)
    const value = values.name
    const target = user?.id === userId ? 'me' : userId

    try {
      await UserServiceV4.updateProfile(target, { name: value })

      if (!modalProps.props) return
      if (!modalProps.props.user) return

      dispatch(
        setModalProps({
          open: false,
          props: {
            ...modalProps.props,
            user: {
              ...modalProps.props.user,
              name: value
            }
          }
        })
      )
    } catch (e) {
      console.error(e)
      dispatch(
        openToast({
          variant: ToastVariant.error,
          props: {
            text: 'Failed saving name',
            description: (e as any).response?.data?.message ?? 'There was a problem while saving your name.'
          }
        })
      )
      setTimeout(() => dispatch(closeToast()), 5000)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box>
      <Header>
        <Typography className="title">Change Name</Typography>
        <IconButton onClick={handleClose}>
          <CloseChipIcon />
        </IconButton>
      </Header>

      <Formik initialValues={initialValues} validationSchema={nameSchema} onSubmit={handleSave}>
        {({ isValid, errors }) => (
          <Form>
            <Content userrole="">
              <Box className="input-wrapper">
                <ControlledTextField
                  helperText={errors.name}
                  variant="outlined"
                  label="Name"
                  name="name"
                  autoComplete="off"
                  fullWidth
                  required
                />
              </Box>
            </Content>
            <Actions>
              <ThemeButton
                themevariant="primary"
                type="submit"
                disabled={!isValid || loading}
                endIcon={loading && <CircularProgress size="20px" />}
              >
                Save
              </ThemeButton>
            </Actions>
          </Form>
        )}
      </Formik>
    </Box>
  )
}

export default ChangeName
